module.exports = __webpack_public_path__ + "static/media/IMG_4383.680de464.jpg";